/* Round Shopify Inbox's chat button to match the rest of the site.

   Why this needs JavaScript at all: Inbox renders its launcher inside a
   <shopify-chat> element's SHADOW ROOT. Shadow DOM is a style boundary — no
   selector in any theme stylesheet can reach inside it, however specific. The
   root is OPEN, though, which means script can append a <style> to it. That is
   the only route in, so this file exists rather than a CSS rule.

   This deliberately hooks a third-party app's internal class name (.activator).
   If Shopify ever renames it the rule simply stops matching and the button goes
   back to its stock 16px — nothing breaks, the corners just stop agreeing. Check
   here first if that happens.

   The button also mounts asynchronously, well after DOMContentLoaded, so this
   watches for it rather than looking once. Both the observer and the polling
   stop themselves so nothing runs for the life of the page. */
(function () {
  'use strict';

  var RADIUS = '7px';
  var HOST = 'shopify-chat';
  var MARK = 'data-wa-radius';
  var DEADLINE = 20000; /* give up after 20s — if it hasn't mounted by then, chat is off on this page */

  function paint() {
    var host = document.querySelector(HOST);
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.querySelector('style[' + MARK + ']')) return true; /* already done */

    var style = document.createElement('style');
    style.setAttribute(MARK, '');
    /* !important because the app sets the radius on the element itself. Both the
       launcher and the nudge bubble beside it are covered. */
    style.textContent =
      '.activator,.activator-nudge{border-radius:' + RADIUS + ' !important}';
    host.shadowRoot.appendChild(style);
    return true;
  }

  if (paint()) return;

  var stop = function () {
    if (observer) observer.disconnect();
    clearInterval(timer);
    clearTimeout(giveUp);
  };

  /* The host element can appear before its shadow root is populated, so a
     childList observer on <body> alone can fire too early. The interval is the
     backstop for exactly that case. */
  var observer = new MutationObserver(function () { if (paint()) stop(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var timer = setInterval(function () { if (paint()) stop(); }, 400);
  var giveUp = setTimeout(stop, DEADLINE);
})();
